import React from "react"
import { Progress } from "@carrotfertility/carotene-core"
import useGetBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { CarrotCollectiveLandingPage } from "./CarrotCollectiveLandingPage"

export function CarrotCollectiveRoute(): JSX.Element {
  const benefitQuery = useGetBenefit()

  if (benefitQuery.isLoading) {
    return <Progress />
  }

  return <CarrotCollectiveLandingPage />
}
